module.exports = __webpack_public_path__ + "img/684.a80aeedc.jpg";